import React from "react"
import styled from "styled-components"
import Slick from "react-slick"
import i18n from "@/i18n"

const Section = styled.section`
    background: #fff;
    display: flex;
    width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    line-height: 1;
    justify-content: center;
    padding: 60px 0 20px 0;
`

const Header = styled.header`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
`

const MainHeading = styled.h2`
    color: #222;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: -0.68px;
`

const HeadingGroup = styled.div`
    display: flex;
    margin-top: 4px;
    align-items: flex-start;
    gap: 4px;
    white-space: nowrap;
    justify-content: flex-start;
`

const EfficiencyWrapper = styled.div`
    display: flex;
    min-width: 240px;
    align-items: center;
    gap: 6px;
    justify-content: flex-start;
`

const SubHeading = styled.h3`
    color: #222;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: -0.68px;
    align-self: stretch;
    margin: auto 0;
`

const HighlightBadge = styled.div`
    border-radius: 999px;
    background-color: #83c308;
    align-self: stretch;
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    color: #fff;
    justify-content: center;
    margin: auto 0;
    padding: 6px 16px;
`

const BadgeText = styled.span`
    font-size: 34px;
    font-weight: 700;
    letter-spacing: -0.68px;
    z-index: 0;
    width: 96px;
    margin: auto 0;
    color: white;
`

const BadgeIcon = styled.span`
    font-size: 20px;
    font-weight: 900;
    letter-spacing: -0.4px;
    align-self: flex-start;
    position: absolute;
    z-index: 0;
    right: 9px;
    top: 0;
    width: 15px;
    height: 26px;
    color: white;
`

const PartnerWrapper = styled.div`
    width: 100vw;
`

const PartnerLogo = styled.img`
    width: 120px;
    height: 100px;
`

export default function PartnerSection() {
    const slickSetting = {
        infinite: true,
        speed: 500,
        touchThreshold: 15,
        slidesToShow: 1,
        slidesToScroll: 4,
        variableWidth: true,
    }
    const partners = Array.from({ length: 25 }, (_, i) => `/images/common/newlanding2024/partners/LOGO - ${i + 1}.png`)

    return (
        <Section>
            <Header>
                <MainHeading>{i18n.t("common.landing.partner.text_1")}</MainHeading>
                <HeadingGroup>
                    <EfficiencyWrapper>
                        <SubHeading>{i18n.t("common.landing.partner.text_2")}</SubHeading>
                        <HighlightBadge>
                            <BadgeText>{i18n.t("common.landing.top.banner.plus")}</BadgeText>
                            <BadgeIcon>+</BadgeIcon>
                        </HighlightBadge>
                    </EfficiencyWrapper>
                    <SubHeading>{i18n.t("common.landing.partner.text_4")}</SubHeading>
                </HeadingGroup>
            </Header>
            <PartnerWrapper>
                <Slick {...slickSetting}>
                    {
                        partners.map((partner, index) => (
                            <PartnerLogo
                                key={index}
                                loading="lazy"
                                src={partner}
                                alt={`logo-${index + 1}`}
                            />
                        ))
                    }
                </Slick>
            </PartnerWrapper>
        </Section>
    );
}